//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.AlignmentMethodBuilder.js";
import "../GeometricUtilities/GeometricUtilities.FeatureOptions.js";
import "../GeometricUtilities/GeometricUtilities.Continuity.js";
import "../GeometricUtilities/GeometricUtilities.FlowDirection.js";
import "../no/SectionList.js";
import "../GeometricUtilities/GeometricUtilities.Rebuild.js";
import "../no/GeometricUtilities.js";
import "../no/ObjectList.js";
let d=[[[1,"AlignmentMethod",0,"GeometricUtilities.AlignmentMethodBuilder",1],[1,"BodyPreference",0,"GeometricUtilities.FeatureOptions",1],[0,"CurvatureTolerance",1,1],[1,"FirstGuideContinuity",0,"GeometricUtilities.Continuity",1],[1,"FirstSectionContinuity",0,"GeometricUtilities.Continuity",1],[1,"FlowDirection",0,"GeometricUtilities.FlowDirection",1],[1,"GuideList",0,"SectionList",1],[1,"GuideRebuild",0,"GeometricUtilities.Rebuild",1],[0,"IntersectionTolerance",1,1],[1,"LastGuideContinuity",0,"GeometricUtilities.Continuity",1],[1,"LastSectionContinuity",0,"GeometricUtilities.Continuity",1],[0,"PositionTolerance",1,1],[1,"SectionList",0,"SectionList",1],[1,"SectionRebuild",0,"GeometricUtilities.Rebuild",1],[0,"SplitOutputAlongBoundaryCurves",1,1],[0,"TangentTolerance",1,1],[0,"Transition",1,1]],[],[]];
SPLM.Features.StudioSurfaceBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StudioSurfaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StudioSurfaceBuilder.TransitionOptions = Object.freeze({
    "NormalToEndSections" : "NormalToEndSections", "NormalToAllSections" : "NormalToAllSections", "Cubic" : "Cubic", "LinearAndBlend" : "LinearAndBlend", "NoEndConstraint" : "NoEndConstraint"});

export default SPLM;